/**
 * #322 — the dashboard map's last centre, zoom and filter, kept in memory for this page load.
 * Leaving the dashboard and coming back restores it (#290); a reload or a new tab starts from
 * the fleet view (client request 2026-10-13). #290 kept it in sessionStorage, which survives a
 * reload. Login and logout clear it (authStore). #363 — the Google map / Site map choice too.
 */
import { emptyMapPinFilter, type MapPinFilter } from '@/lib/mapPinFilter'

export interface MapCamera {
  center: { lat: number; lng: number }
  zoom: number
}
export interface DashboardMapView {
  camera: MapCamera | null
  filter: MapPinFilter
}

// A module variable lives exactly as long as the page: router navigation keeps it, a reload resets it.
let view: DashboardMapView = { camera: null, filter: emptyMapPinFilter }

export const loadMapView = (): DashboardMapView => ({ ...view })
export const saveMapCamera = (camera: MapCamera) => { view = { ...view, camera } }
export const saveMapFilter = (filter: MapPinFilter) => { view = { ...view, filter } }

/** #363 — Google map or Site map in the map window, and the group whose drawing the site map last showed (kept
 *  on the Google map, so the next switch opens the same drawing). Kept like the camera: this page load only. */
export interface MapMode {
  view: 'google' | 'site'
  groupId: number | null
}
const GOOGLE_MAP: MapMode = { view: 'google', groupId: null }
let mode: MapMode = GOOGLE_MAP

export const loadMapMode = (): MapMode => ({ ...mode })
export const saveMapMode = (next: MapMode) => { mode = { ...next } }

export function clearMapView() {
  view = { camera: null, filter: emptyMapPinFilter }
  mode = GOOGLE_MAP
}
